<div class="container mt-5 mb-5">
  <h2 class="mb-4">{{ dataModel.title }}</h2>
  <form [formGroup]="informationForm" (ngSubmit)="onSubmit()">
    <!-- Client Information Section -->
    <div class="card mb-1">
      <div class="card-header bg-secondary text-white">My Information</div>
      <div class="card-body">
        <div class="row mb-3">
          <div class="col">
            <div class="input-group has-validation">
              <a class="input-group-text text-danger text-decoration-none" title="This field is required"><b>*</b></a>
              <div class="form-floating" [class.is-invalid]="informationForm.get('username')?.invalid && informationForm.get('gender')?.touched">
                <input 
                  id="username"
                  [class.is-invalid]="informationForm.get('username')?.invalid && informationForm.get('username')?.touched"
                  class="form-control" 
                  formControlName="username"
                  placeholder="Your username"
                  autocomplete=on
                  required
                >
                <label for="username" class="form-label">Username</label>
              </div>
              <div class="invalid-feedback">
                Username is required.
              </div>
            </div>
          </div>
        </div>
        <div class="row mb-3">
          <div class="col">
            <div class="input-group has-validation">
              <a class="input-group-text text-danger text-decoration-none" title="This field is required"><b>*</b></a>
              <div class="form-floating" [class.is-invalid]="informationForm.get('gender')?.invalid && informationForm.get('gender')?.touched">
                <input 
                  id="gender"
                  [class.is-invalid]="informationForm.get('gender')?.invalid && informationForm.get('gender')?.touched"
                  class="form-control" 
                  formControlName="gender"
                  placeholder="Type to search..."
                  autocomplete=sex
                  list="gendersList" 
                  required
                >
                <datalist id="gendersList">
                  @for (gender of allGenders; track gender) {
                    <option value="{{gender}}"></option>
                  }
                </datalist>
                <label for="gender" class="form-label">Gender</label>
              </div>
              <div class="invalid-feedback">
                Gender is required.
              </div>
            </div>
          </div>
          <div class="col">
            <div class="input-group has-validation">
              <a class="input-group-text text-danger text-decoration-none" title="This field is required"><b>*</b></a>
              <div class="form-floating" [class.is-invalid]="informationForm.get('firstName')?.invalid && informationForm.get('firstName')?.touched">
                <input type="text" 
                  id="firstName"
                  [class.is-invalid]="informationForm.get('firstName')?.invalid && informationForm.get('firstName')?.touched"
                  class="form-control" 
                  formControlName="firstName"
                  placeholder="Enter your first name" 
                  autocomplete="given-name" 
                  required
                >
                <label for="firstName" class="form-label">First name</label>
              </div>
              <div class="invalid-feedback">
                Name is required.
              </div>
            </div>
          </div>
        </div>
        <div class="row mb-3">
          <div class="col">
            <div class="form-floating">
              <input type="text" 
                id="middleName"
                class="form-control" 
                formControlName="middleName" 
                placeholder="Enter your middle name" 
                autocomplete="additional-name" 
              >
              <label for="middleName" class="form-label">Middle name</label>
            </div>
          </div>
          <div class="col">
            <div class="input-group has-validation">
              <a class="input-group-text text-danger text-decoration-none" title="This field is required"><b>*</b></a>
              <div class="form-floating" [class.is-invalid]="informationForm.get('lastName')?.invalid && informationForm.get('lastName')?.touched">
                <input type="text" 
                  id="lastName"
                  [class.is-invalid]="informationForm.get('lastName')?.invalid && informationForm.get('lastName')?.touched"
                  class="form-control" 
                  formControlName="lastName" 
                  placeholder="Enter your last name" 
                  autocomplete="family-name" 
                  required
                >
                <label for="lastName" class="form-label">Last name</label>
              </div>
              <div class="invalid-feedback">
                Last name is required.
              </div>
            </div>
          </div>
        </div>
        <div class="row mb-3">
          <div class="col">
            <div class="input-group has-validation">
              <a class="input-group-text text-danger text-decoration-none" title="This field is required"><b>*</b></a>
              <div class="form-floating" [class.is-invalid]="informationForm.get('email')?.invalid && informationForm.get('email')?.touched">
                <input type="email" 
                  id="email" 
                  class="form-control" 
                  [class.is-invalid]="informationForm.get('email')?.invalid && informationForm.get('email')?.touched"
                  formControlName="email" 
                  placeholder="Enter your email" 
                  autocomplete="email" 
                >
                <label for="email" class="form-label">Your email</label>
              </div>
              <div class="invalid-feedback">
                Valid email is required (john.doe&#64;example.net).
              </div>
            </div>
          </div>
          <div class="col">
            <div class="input-group">
              <a class="input-group-text text-danger text-decoration-none" title="This field is required"><b>*</b></a>
              <input type="tel" 
                class="form-control" 
                id="phone"
                name="phone"
                placeholder="Enter your phone"
                formControlName="phone"
                autocomplete="mobile"
                #phone
              >
            </div>
          </div>
        </div>
        <div class="row mb-3">
          <div class="col-12">
            <div class="input-group has-validation">
              <a class="input-group-text text-danger text-decoration-none" title="This field is required"><b>*</b></a>
              <div class="form-floating" [class.is-invalid]="informationForm.get('businessName')?.invalid && informationForm.get('businessName')?.touched">
                <input type="businessName" 
                  id="businessName" 
                  class="form-control" 
                  [class.is-invalid]="informationForm.get('businessName')?.invalid && informationForm.get('businessName')?.touched"
                  formControlName="businessName" 
                  placeholder="Enter your business name" 
                  autocomplete="organization"
                >
                <label for="businessName" class="form-label">Your business name</label>
              </div>
              <div class="invalid-feedback">
                Business name is required.
              </div>
            </div>
          </div>
        </div>
        <app-address-input (addressesSelected)="onAddressSelected($event)" [billAddress]="billAddress" [postAddress]="postAddress"></app-address-input>
      </div>
    </div>

    <div class="row">
      <div class="col">
        <button type="reset" 
          class="btn btn-danger w-100"
          (click)="cancel()"
        >Cancel</button>
      </div>
      <div class="col">
        <!-- Submit Button -->
        <button type="submit" 
          class="btn btn-success w-100" 
          [class.btn-success]="!informationForm.invalid"
          [class.btn-warning]="informationForm.invalid" 
          [disabled]="informationForm.invalid"
        >Update</button>
      </div>
    </div>
  </form>
</div>
